import { render, staticRenderFns } from "./create-button.vue?vue&type=template&id=e524bd74&scoped=true"
import script from "./create-button.vue?vue&type=script&lang=js"
export * from "./create-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e524bd74",
  null
  
)

export default component.exports